import { fmt, ddmmyyyy } from "@/lib/format";

export const FIELD_LABELS = {
  date: "Date", op_bal: "Op Bal", deposit: "Deposit", withdrawal: "Withdrawal", cashout: "Cashout", cashout_note: "Cashout description", cashout_to: "Paid to", bonus: "Bonus",
  overlimit: "Overlimit", freeze_bal: "Freeze Bal", available_bal: "Available Bal", is_settlement: "Settlement",
  diff: "Diff", note: "Note", reason: "Reason", sheet: "Sheet",
};

export const fieldValue = (k, v) => {
  if (v === null || v === undefined || v === "") return k === "op_bal" || k === "freeze_bal" ? "auto" : "—";
  if (k === "date") return ddmmyyyy(v);
  if (k === "is_settlement") return v ? "Yes" : "No";
  if (k === "sheet") return v === "sett" ? "NEW SETT" : "Daily";
  if (typeof v === "number") return fmt(v);
  return String(v);
};

export const ACTION_STYLE = {
  created: "bg-green-100 text-green-800", updated: "bg-sky-100 text-sky-800",
  deleted: "bg-red-100 text-red-800", imported: "bg-violet-100 text-violet-800",
};

export const ChangeList = ({ changes, action }) => (
  <ul className="mt-1.5 space-y-0.5 text-[12px]">
    {changes.map((c) => (
      <li key={c.field} className="flex flex-wrap gap-x-1.5 font-mono">
        <span className="text-slate-500 font-sans font-semibold">{FIELD_LABELS[c.field] || c.field}:</span>
        {action === "updated" ? (
          <><span className="line-through text-red-700/80">{fieldValue(c.field, c.old)}</span><span>→</span><span className="text-green-800 font-semibold">{fieldValue(c.field, c.new)}</span></>
        ) : <span>{fieldValue(c.field, action === "deleted" ? c.old : c.new)}</span>}
      </li>
    ))}
  </ul>
);
